export const getNormalizedValue = (value: string): number => {
  if (value === '') {
    return 0;
  }
  const withoutChars = value.replace(/[^0-9.,]+/g, '');
  if (withoutChars === '') {
    return 0;
  }
  const withoutComma = withoutChars.replace(/[,]/g, '.');
  if (withoutComma === '.') {
    return 0;
  }
  const withoutDotExceptLast = withoutComma.replace(/[.](?=.*[.])/g, '');

  if (withoutDotExceptLast.match(/[.]/g)) {
    const [integer, decimal] = withoutDotExceptLast.split('.');

    if (decimal.length === 0) {
      return parseFloat(integer);
    }

    return parseFloat(`${integer}.${decimal.substring(0, 2)}`);
  }

  return parseFloat(withoutDotExceptLast);
};
